import React, { Component } from 'react';
import { TweenMax } from 'gsap';
import progressListener from './lib/progressListener';

import PlayPauseButton from '../../ui/PlayPauseButton';

import style from './StoryProgressBar.module.scss';

class StoryProgressBar extends Component {
  state = {
    currentTime: 0,
    duration: 1,
  };

  handleProgress = (currentTime, duration) => {
    this.setState({
      currentTime: currentTime,
      duration: duration,
    });
  };

  getProgressWidth = (currentTime, duration) => {
    return currentTime / duration * 100 + '%';
  };

  getVideoProgress = i => {
    if (i === this.props.activeVideo) {
      return {
        width: this.getProgressWidth(
          this.state.currentTime,
          this.state.duration
        ),
      };
    } else if (i < this.props.activeVideo) {
      return {
        width: '100%',
      };
    } else {
      return {
        width: 0,
      };
    }
  };

  componentDidMount() {
    // Set unsubscribe method
    this.unsubscribe = progressListener.subscribe(this.handleProgress);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    const {
      isPlaylistOpen,
      playlistVideoData,
      onPlayPauseClick,
      navigateVideos,
    } = this.props;

    return (
      <div
        style={{ pointerEvents: isPlaylistOpen ? '' : 'none' }}
        className={`story-nav ${style.storyNavigation}`}
      >
        <PlayPauseButton
          onPlayPauseClick={onPlayPauseClick}
          isVideoPaused={this.props.isVideoPaused}
        />

        {playlistVideoData.map((video, i) => {
          return (
            <div
              key={`progressBar-${i}`}
              className={style.progressWrapper}
              // Remove anonymous function and make this its own component
              onClick={() => navigateVideos(i)}
            >
              <div className={style.progressBar} />
              <div
                className={style.progress}
                style={this.getVideoProgress(i)}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default StoryProgressBar;



// WEBPACK FOOTER //
// ./src/components/global/playlist/StoryProgressBar.js